import { $, $$ } from '../utils/dom.js';
import { gsap } from '../vendor/vendor-globals.js';

const IMAGE_WAIT_MS = 3000;
const LOGO_DIP_OFFSET = 60;
const MOBILE_MQ = '(max-width: 768px)';

export function initLoader() {
  const root = document.documentElement;
  const status = $('[data-component="loader"]');

  if (!status || root.getAttribute('data-loader') !== 'active') {
    return () => { };
  }

  const main = $('.main');
  const hero = $('.hero');

  if (!hero) {
    finishWithoutAnimation(root, main, status);
    return () => { };
  }

  if (window.matchMedia(MOBILE_MQ).matches) {
    finishWithoutAnimation(root, main, status);
    return () => { };
  }

  const logo = $('.header__logo');
  const chrome = $$('.header__toggle-container, .header__button-container');
  const inHero = (sel) => (hero ? $(sel, hero) : null);
  const loadingWrapper = inHero('.hero__image-loading-wrapper');
  const media = inHero('.hero__image-container');
  const image = inHero('.hero__image');
  const title = inHero('.hero__title');
  const actions = inHero('.hero__actions');
  const edges = hero ? $$('.hero__edge', hero) : [];
  const animated = [logo, ...chrome, media, image, title, actions, ...edges].filter(Boolean);
  const copyShift = 50;
  const startY = logo ? logoShift(logo) : 0;

  let settled = false;
  let cancelled = false;
  let timeline = null;

  const finish = () => {
    if (settled) {
      return;
    }

    settled = true;
    root.setAttribute('data-loader', 'done');
    root.removeAttribute('aria-busy');
    main?.removeAttribute('inert');
    status.textContent = 'Content loaded';
    gsap.set(animated, { clearProps: 'all' });
  };

  const destroy = () => {
    cancelled = true;
    timeline?.kill();
  };

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    finish();
    return destroy;
  }

  main?.setAttribute('inert', '');

  if (logo) {
    gsap.set(logo, { xPercent: -50, y: startY, scale: 1.5 });
  }

  gsap.set(chrome, { autoAlpha: 0, y: `-${copyShift}` });

  if (!media || !image) {
    finishWithoutAnimation(root, main, status);
    return () => { };
  }

  gsap.set([title, actions, ...edges].filter(Boolean), {
    autoAlpha: 0,
    y: copyShift,
  });

  imageReady(image, IMAGE_WAIT_MS).then(() => {
    if (cancelled) {
      return;
    }

    timeline = gsap.timeline({
      defaults: {
        ease: "expo.out",
        // ease: "power4.out",
        
      },
      onComplete: finish,
    });

    timeline.fromTo(
      image,
      { height: '0%' },
      {
        height: '100%',
        duration: 1
      },
    );
    if (logo) {
      timeline.to(logo, {
        y: startY - LOGO_DIP_OFFSET,
        duration: 1
      },
        '<');
    }

    timeline.to(logo, {
      y: 0,
      scale: 1,
      duration: 2,
      // ease: "power2.inOut",
    });

    timeline.to(
      media,
      {
        width: '100%',
        height: '100%',
        top: '0%',
        duration: 2,
        // ease: 'power2.out'
        // ease: "power2.inOut",
      },
      '<',
    );
    timeline.to(
      loadingWrapper,
      {
        width: '100%',
        duration: .65,
        // ease: 'none'
        // ease: "power3.out",
      },
      '<',
    );

    timeline.to(chrome, { autoAlpha: 1, y: 0, duration: 0.5, }, '-=1.5');
    timeline.to(title, { autoAlpha: 1, y: 0, duration: 1.2, }, "-=1");
    timeline.to(actions, { autoAlpha: 1, y: 0, duration: 1.2, }, "-=1");
    timeline.to(edges, { autoAlpha: 1, y: 0, duration: 1.2, }, '<');
  });

  return destroy;
}

function finishWithoutAnimation(root, main, status) {
  root.setAttribute('data-loader', 'done');
  root.removeAttribute('aria-busy');
  main?.removeAttribute('inert');
  status.textContent = 'Content loaded';
}


function logoShift(logo) {
  const header = logo.closest('.header');
  const headerHeight = header ? header.offsetHeight : 0;
  return window.innerHeight * 0.5 - headerHeight / 2;
}

function imageReady(image, limitMs) {
  const loaded = image.decode
    ? image.decode().catch(() => { })
    : waitForLoad(image);

  let timeoutId;
  const timeout = new Promise((resolve) => {
    timeoutId = window.setTimeout(resolve, limitMs);
  });

  return Promise.race([loaded, timeout]).finally(() => {
    window.clearTimeout(timeoutId);
  });
}

function waitForLoad(image) {
  if (image.complete) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    image.addEventListener('load', resolve, { once: true });
    image.addEventListener('error', resolve, { once: true });
  });
}
